import { useState } from "react";
import { minMaxRangeError, outOfRangeError, defaultMessage } from "./constants";

export const usePriceRange = ({
  priceRange: { priceMin, priceMax, search },
  setPriceRange
}) => {
  const [validationError, setValidationError] = useState(false);
  const [rangeMessage, setRangeMessage] = useState(defaultMessage);
  const [range, setRange] = useState({
    min: search ? priceMin : "",
    max: search ? priceMax : ""
  });

  const validateRange = (min, max) => {
    const lowestValue = 5;
    const isValidMin = min === "" || min >= lowestValue;
    const isValidMax = max === "" || max >= min;

    return isValidMin && isValidMax;
  };

  const setRangeWithValidations = (min, max) => {
    setRange({ min, max });
    const hasError = !validateRange(min, max);

    if (hasError) {
      const isMinGreaterThanMax = max && max < min;
      setValidationError(true);
      setRangeMessage(isMinGreaterThanMax ? minMaxRangeError : outOfRangeError);
      return;
    }

    setValidationError(false);
    setRangeMessage(defaultMessage);
    setPriceRange({ priceMin: min, priceMax: max });
  };

  return {
    range,
    rangeMessage,
    validationError,
    setRange,
    setRangeWithValidations
  };
};
